import React, { useEffect, useState } from 'react'
import { motion } from "framer-motion";
import StaffProfileCard from '../../sections/StaffProfileCard';
import { useLocation, useNavigate } from 'react-router';
import { StaffGetDetail, StaffUpdate } from '../../../api/orgService';
import useApi from '../../../api/useApi';
import { toast } from 'react-toastify';

function StaffAdminRead() {

  // StaffUpdate =(id,staff_data)

  const { request:getStaff,data:getStaffData,error:getStaffError,isLoading:getStaffIsLoading}=useApi(StaffGetDetail)
  const { request:updateStaff,data:updateStaffData,error:updateStaffError,isLoading:updateStaffIsLoading}=useApi(StaffUpdate)
    
  const location = useLocation()
  const navigate = useNavigate()

  const [staff,setStaff] = useState({})

  useEffect(()=>{
    if(location?.state?.staffId){
      getStaff(location?.state?.staffId)
    }
  },[location])

  useEffect(()=>{
    // console.log("staff data: ",getStaffData)
    if(getStaffData?.data){
      // console.log(getStaffData?.data)
      setStaff(getStaffData?.data)
    }
  },[getStaffData])

  useEffect(()=>{
      if(updateStaffData){
        if(updateStaffData?.status===200){
          toast.success(`${JSON.stringify(updateStaffData?.data)}, successful`,{position: "top-center"});
          // customNavigate("/t","","home",{refresh:"classes"})
          navigate("/staff/profile/",{state:{redirect:"list-staff"}})
        }
      }
    },[updateStaffData])
  
    useEffect(()=>{
      if(updateStaffError){
  
          toast.error(`${JSON.stringify(updateStaffError?.response?.data,null,2)}`,{position: "top-center"});
      }
    },[updateStaffError])
    
  // console.log("Here: ",staff)
  return (
    <StaffProfileCard 
    staff={staff} 
    loading={getStaffIsLoading} 
    onSave={updateStaff}
    updateLoading = {updateStaffIsLoading}
    />
  );
}

export default StaffAdminRead